// import { reportToDMP } from './requests/report.js';
// import { debounce } from './utils/index.js';
// const DELAY_TIME = 300
// window.dmp_pop_list = []
// const spliter = ','
/**
 * v-dmp = "{'action': 'click,pop', targetId: item.iId, title: item.sTitle}"
 */
export default Vue => {
    // Vue.directive('dmp', (el, binding) => {
    //     if (!binding.value || !binding.value.action) return
    //     let actions = binding.value.action.replace(/ /g,'').split(',')
    //     let delayReport = debounce(reportDmpPop, DELAY_TIME)
    //     let params = binding.value
    //     actions.forEach((item, index) => {
    //         params.action = item

    //         // 区分action
    //         switch (item) {

    //             // 点击上报
    //             case 'click':
    //                 params.hash = location.hash
    //                 el.addEventListener('click', function clickHandler(e){
    //                     params.action = 'click'

    //                     // 点击时埋下title
    //                     localStorage.dmp_detail_pv_title = params.title
    //                     localStorage.dmp_detail_pv_targetid = params.targetid
    //                     localStorage.dmp_detail_pv_from = params.from
    //                     localStorage.dmp_detail_pv_targettype = params.targettype
    //                     e.target.removeEventListener('click', clickHandler, false)
    //                     reportToDMP(params)
    //                 }, false)
    //                 break;

    //             // 曝光上报
    //             case 'pop':
    //                 function listener() {
    //                     // 判断是否处于可视区域
    //                     if (el.className.indexOf('hasPop') != -1) return
    //                     let bodyHeight = document.body.clientHeight,
    //                       bodyWidth = document.body.clientWidth,
    //                       curTop = el.getBoundingClientRect().top,
    //                       curLeft = el.getBoundingClientRect().left;
    //                     if (curTop <= bodyHeight && curLeft <= bodyWidth) {
    //                         // 添加到曝光队列
    //                         el.className += ' hasPop'
    //                         window.dmp_pop_list.push(params)
    //                         window.document.body.removeEventListener('touchend', listener, true)
    //                         delayReport()
    //                     }
    //                 }
    //                 // 绑定touch
    //                 window.document.body.addEventListener('touchend', listener ,true)

    //                 break;
    //             default:
    //                 reportToDMP(params)
    //         }
    //     })


    //     /**
    //      * DMP 批量曝光上报方法
    //      */
    //     function reportDmpPop() {
    //         // 参数处理
    //         let pop_list = window.dmp_pop_list.slice(0)
    //         if (!pop_list.length) return
    //         window.dmp_pop_list = []
    //         let params = pop_list[0]
    //         params.action = 'pop'
    //         params.targetid = pop_list.map(item => item.targetid).join(spliter)
    //         // params.targettype = pop_list.map(item => item.targettype).join(spliter)
    //         params.title = pop_list.map(item => item.title ? item.title.replace(/\,/g,'，') : '').join(spliter)
    //         // params.from = pop_list.map(item => item.from).join(spliter)
    //         // params.tag = pop_list.map(item => item.tag).join(spliter)
    //         reportToDMP(params)
    //     }
    // })
}
